<template>
  <div class="form-group row">
    <label class="col-12">Motivo: <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.arquivar.motivo.$error
      }">
        <textarea
          class="form-control"
          rows="3"
          v-model.trim="$v.arquivar.motivo.$model"
        />
      </div>
      <div class="error" v-if="!$v.arquivar.motivo.required">O campo é obrigatório</div>
    </div>
    <div class="modal-body text-md-right text-sm-center">
      <button type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
          closeModalEvent()
        }">Cancelar</button>
      <button type="button" class="btn btn-outline-primary m-1" @click.prevent="desarquivarTramitacao()">Desarquivar</button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VirtusService from '@/services/VirtusService'

export default {
  name: 'desarquivar',

  components: {},

  props: {
    closeModalEvent: { required: true, type: Function },
    protocolo: { required: true, type: String },
    atualizarConsulta: { required: true, type: Function }
  },

  data () {
    return {
      arquivar: {
        motivo: ''
      }
    }
  },

  validations: {
    arquivar: {
      motivo: {
        required
      }
    }
  },

  created () {
    this.service = new VirtusService()
  },

  methods: {
    desarquivarTramitacao () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      const dadosSessao = this.$store.getters.getDadosSessao.sessao
      this.service.desarquivarProtocolo({
        ...this.arquivar,
        numeroProcesso: this.protocolo
      }, dadosSessao).then((data) => {
        this.closeModalEvent()
        this.atualizarConsulta()
      })
    }
  }
}
</script>
